import { TableCell, TableRow, Typography } from "@mui/material";
import moment from "moment";
import TableActions from "src/common/TableActions";
import { useApiMutation } from "src/hooks/useApiMutation";
import { getStatusLabelInvoiceStatus } from "src/Utils/Combined";
import type { IExhibitorInvoiceList } from "../type/exhibitorType";

type IProps = {
	allAdmin: IExhibitorInvoiceList;
	index: number;
	paginationSkip: number;
};

const ExhibitorInvoiceTableRow = ({
	allAdmin,
	index,
	paginationSkip,
}: IProps) => {
	const {
		mutate: deleteExInv,
		isPending,
		isSuccess,
	} = useApiMutation<void, void>({
		method: "DELETE",
		endPoint: `/api/admin/exhibitor/invoice/${allAdmin.id}`,
		invalidateQueries: ["Exhibitor"],
	});

	return (
		<>
			<TableRow hover>
				<TableCell>
					<Typography
						variant='body1'
						color='text.primary'
						gutterBottom
						noWrap
					>
						{index + 1 + Number(paginationSkip)}
					</Typography>
				</TableCell>
				<TableCell>
					<Typography
						variant='body1'
						color='text.primary'
						gutterBottom
						noWrap
					>
						{moment(allAdmin?.invoice_date).format("DD-MM-YYYY")}
					</Typography>
				</TableCell>
				<TableCell>
					<Typography
						variant='body1'
						color='text.primary'
						gutterBottom
						noWrap
					>
						{allAdmin?.invoice_no}
					</Typography>
				</TableCell>
				<TableCell>
					<Typography
						variant='body1'
						color='text.primary'
						gutterBottom
						noWrap
					>
						{" "}
						{allAdmin?.user_fair_member_company_name}
					</Typography>
				</TableCell>
				<TableCell>
					<Typography
						variant='body1'
						color='text.primary'
						gutterBottom
						noWrap
					>
						{allAdmin.user_fair_member_company_email}
					</Typography>
				</TableCell>
				<TableCell>
					<Typography
						variant='body1'
						color='text.primary'
						gutterBottom
						noWrap
					>
						{allAdmin?.net_total}
					</Typography>
				</TableCell>
				<TableCell>
					<Typography
						variant='body1'
						color='text.primary'
						gutterBottom
						noWrap
					>
						{allAdmin?.due}
					</Typography>
				</TableCell>
				<TableCell>
					{getStatusLabelInvoiceStatus(allAdmin?.status)}
				</TableCell>
				<TableActions
					showView
					viewLink={`/exhibitor/invoice-list/${allAdmin?.id}`}
					showDelete
					handleDeleteFun={() => deleteExInv()}
				/>
			</TableRow>
		</>
	);
};

export default ExhibitorInvoiceTableRow;
